import React from "react";
import Styles from "./NotifyModal.module.css";
import { Modal } from "@mui/material";
import { ReactComponent as TenderNotify } from "../../assets/images/TenderNotify.svg";

const NotifyModal = ({ open, handleClose, type, header, text }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="verify-popup"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${Styles.notifyModalContainer}`}>
        <TenderNotify style={{ height: "115px", width: "115px" }} />
        <div className={Styles.contentHeader}>{header}</div>
        <div className={Styles.displayText}>{text}</div>
        <div
          onClick={handleClose}
          className={`activeButton_type_2 ${Styles.notifyButtons}`}
        >
          Notify Me
        </div>
      </div>
    </Modal>
  );
};

export default NotifyModal;
